import {apiService} from '../apiService';

export const medicinesService = apiService.injectEndpoints({
    endpoints: (builder) =>
        ({
            getMedicineLookups: builder.query({
                query: () => ({
                    url: '/medicines/lookup'
                })
            }),
            addMedicineLookup: builder.mutation({
                query: (body) => ({
                    url: '/medicines/lookup',
                    method: 'POST',
                    data: body
                })
            }),
            updateMedicineLookup: builder.mutation({
                query: ({id, ...body}) => ({
                    url: `/medicines/lookup/${id}`,
                    method: 'PUT',
                    data: body
                })
            }),
            addStarterMedicines: builder.mutation({
                query: () => ({
                    url: '/medicines/lookup/starter',
                    method: 'POST'
                })
            }),
            getDosageUnits: builder.query({
                query: () => ({
                    url: '/medicines/dosage-units'
                })
            }),
            deleteMedicineLookup: builder.mutation({
                query: (lookupId) => ({
                    url: `/medicines/lookup/${lookupId}`,
                    method: 'DELETE'
                })
            }),
            getStudentMedicines: builder.query({
                query: (studentId) => ({
                    url: `/medicines/student/${studentId}`
                })
            }),
            addStudentMedicine: builder.mutation({
                query: ({studentId, ...body}) => ({
                    url: `/medicines/student/${studentId}`,
                    method: 'POST',
                    data: body
                })
            }),
            // Save after a change: the school and the parents are emailed, as for any other section.
            saveStudentMedicines: builder.mutation({
                query: (studentId) => ({
                    url: `/medicines/student/${studentId}/save`,
                    method: 'POST'
                })
            }),
            updateStudentMedicine: builder.mutation({
                query: ({studentMedicineId, ...body}) => ({
                    url: `/medicines/student-medicine/${studentMedicineId}`,
                    method: 'PUT',
                    data: body
                })
            }),
            removeStudentMedicine: builder.mutation({
                query: (studentMedicineId) => ({
                    url: `/medicines/student-medicine/${studentMedicineId}`,
                    method: 'DELETE'
                })
            }),
            addMedicineBox: builder.mutation({
                query: ({studentMedicineId, ...body}) => ({
                    url: `/medicines/student-medicine/${studentMedicineId}/box`,
                    method: 'POST',
                    data: body
                })
            }),
            updateMedicineBox: builder.mutation({
                query: ({boxId, ...body}) => ({
                    url: `/medicines/box/${boxId}`,
                    method: 'PUT',
                    data: body
                })
            }),
            disposeMedicineBox: builder.mutation({
                query: (boxId) => ({
                    url: `/medicines/box/${boxId}/dispose`,
                    method: 'POST'
                })
            }),
            undoDisposeMedicineBox: builder.mutation({
                query: (boxId) => ({
                    url: `/medicines/box/${boxId}/in-use`,
                    method: 'POST'
                })
            }),
            deleteMedicineBox: builder.mutation({
                query: (boxId) => ({
                    url: `/medicines/box/${boxId}`,
                    method: 'DELETE'
                })
            }),
            dispenseMedicine: builder.mutation({
                query: ({studentMedicineId, ...body}) => ({
                    url: `/medicines/student-medicine/${studentMedicineId}/dispense`,
                    method: 'POST',
                    data: body
                })
            }),
            getMedicineDispenses: builder.query({
                query: (studentId) => ({
                    url: `/medicines/student/${studentId}/dispenses`
                })
            })
        })
});

export const {
    useGetMedicineLookupsQuery,
    useAddMedicineLookupMutation,
    useAddStarterMedicinesMutation,
    useUpdateMedicineLookupMutation,
    useGetDosageUnitsQuery,
    useDeleteMedicineLookupMutation,
    useGetStudentMedicinesQuery,
    useAddStudentMedicineMutation,
    useSaveStudentMedicinesMutation,
    useUpdateStudentMedicineMutation,
    useRemoveStudentMedicineMutation,
    useAddMedicineBoxMutation,
    useUpdateMedicineBoxMutation,
    useDisposeMedicineBoxMutation,
    useUndoDisposeMedicineBoxMutation,
    useDeleteMedicineBoxMutation,
    useDispenseMedicineMutation,
    useGetMedicineDispensesQuery
} = medicinesService;
